import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import React from 'react';

export const useToast = () => {

    const toastId = React.useRef(null);

    const showToast = (status, message,) => {

        const defaultOptions = {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            newestOnTop: false,
            closeOnClick: false,
            rtl: false,
            pauseOnFocusLoss: true,
            draggable: true,
            pauseOnHover: true,
            theme: "colored",
            preventDuplicates: true
        }


        
        // switch (status) {
        //     case 'success':
        //         toast.success(message, defaultOptions)
        //         break;
        //     case 'error':
        //         toast.error(message, defaultOptions)
        //         break;
        //     case 'info':
        //         toast.info(message, defaultOptions)
        //         break;
        //     case 'warn':
        //         toast.warn(message, defaultOptions)
        //         break;
        //     default:
        //         toast(message, defaultOptions) //👉 Notificación genérica
        //         break
        // }
        

        if (status === 200) {
//console.log('cayó aca')
            if(! toast.isActive(toastId.current)) {
                toastId.current = toast.success(message, defaultOptions);
              }
            
        } else{

            if(! toast.isActive(toastId.current)) {
                toastId.current = toast.error(message, defaultOptions);
              }

        }
    }

    return { showToast }
}
